// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__WUcMf","reviewsStar":"styles_reviewsStar__Ss7fW","reviewsCount":"styles_reviewsCount__Mi2D8"};